
import React from "react";

import Dashboard from "./Dashboard";

function Home() {
  return (
    <>
      <div id="layout-wrapper">
        <Dashboard />
      </div>
    </>
  );
}

export default Home;
